/* eslint-disable react/prop-types */

import React from 'react';
import { Card, CardFooter, CardBody } from 'reactstrap';
import { withFormik } from 'formik';
import { Link, withRouter } from 'react-router-dom';
import { Field, FormAlerts, Button } from '@cordata/buffet';

import {
  adminInstance as axios,
  toastSuccess,
} from '~/utils';

const formEnhancer = withFormik({
  mapPropsToValues: props => ({
    id: props.data && props.data.id,
    firstName: props.data && props.data.relationships.person.attributes.firstName,
    lastName: props.data && props.data.relationships.person.attributes.lastName,
    displayName: props.data && props.data.relationships.person.attributes.displayName,
    specialtyUid: props.data && props.data.attributes.providerSpecialtyUid,
    isInSelections: props.data && props.data.attributes.isInSelections,
  }),

  handleSubmit: (values, { setErrors, setSubmitting, ...bag }) => {
    const { props: { history } } = bag;

    const p = {
      ...values,
    };

    if (!values.id) {
      axios
        .post('/provider', p)
        .then(() => toastSuccess())
        .then(() => history.push('/admin/providers'))
        .catch(e => setErrors({ server: e.errors }))
        .then(() => setSubmitting(false));
    } else {
      axios
        .put(`/provider/${values.id}`, p)
        .then(() => toastSuccess())
        .then(() => history.push('/admin/providers'))
        .catch(e => setErrors({ server: e.errors }))
        .then(() => setSubmitting(false));
    }
  },

  displayName: 'ProvidersKickstarterFormik',
  validateOnChange: false,
  validateOnBlur: false,
});

const ProvidersKickstarterForm = ({
  errors,
  handleSubmit,
  submitCount,
  isSubmitting,
}) => (
  <Card className="rounded-bottom rounded-0 border-top-0">
    <form onSubmit={handleSubmit} noValidate>
      <CardBody>
        { submitCount >= 1 && errors && <FormAlerts errors={errors} /> }

        <Field
          name="isInSelections"
          type="checkbox"
          placeholder="Yes"
        />
      </CardBody>

      <CardFooter className="d-flex">
        <div className="ml-auto">
          <Button
            type="cancel"
            disabled={isSubmitting}
            tag={Link}
            to="/admin/providers"
          >
            Cancel
          </Button>

          <Button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Working ...' : 'Save'}
          </Button>
        </div>
      </CardFooter>
    </form>
  </Card>
);

export default withRouter(formEnhancer(ProvidersKickstarterForm));
